import { PublicTeamGq, PublicTeamGqProps } from './PublicTeamGq';
import { PublicUserGq, PublicUserGqProps } from './PublicUserGq';
import {
  TeamConnectionInvitationGq,
  TeamConnectionInvitationGqProps,
} from './TeamConnectionInvitationGq';

export interface TeamConnectionGq {
  id: number;
  createTime: string;
  sharingTeam?: PublicTeamGq;
  receivingTeam?: PublicTeamGq;
  createdByUser?: PublicUserGq;
  connectedBySharingTeamUser?: PublicUserGq;
  connectedByReceivingTeamUser?: PublicUserGq;
  invitations: TeamConnectionInvitationGq[];
}

export const TeamConnectionGqProps = `
  id
  createTime
  sharingTeam { ${PublicTeamGqProps} }
  receivingTeam { ${PublicTeamGqProps} }
  createdByUser { ${PublicUserGqProps} }
  connectedBySharingTeamUser  { ${PublicUserGqProps} }
  connectedByReceivingTeamUser { ${PublicUserGqProps} }
  invitations { ${TeamConnectionInvitationGqProps} }
`;
